"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPSOLVE = exports.MONEY_MANAGEMENT_INTERNATIONAL = exports.WAJDA_ASSOCIATES = exports.LEGAL_ZOOM = exports.ICE_LEGAL = void 0;
var ICE_LEGAL = 'iceLegal';
exports.ICE_LEGAL = ICE_LEGAL;
var LEGAL_ZOOM = 'legalZoom';
exports.LEGAL_ZOOM = LEGAL_ZOOM;
var WAJDA_ASSOCIATES = 'wajdaAssociates';
exports.WAJDA_ASSOCIATES = WAJDA_ASSOCIATES;
var MONEY_MANAGEMENT_INTERNATIONAL = 'moneyManagementInternational';
exports.MONEY_MANAGEMENT_INTERNATIONAL = MONEY_MANAGEMENT_INTERNATIONAL;
var UPSOLVE = 'upsolve';
exports.UPSOLVE = UPSOLVE;